<template>
  <div>
    <main-head></main-head>
    <router-view class="routerView"></router-view>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainFooter from './../components/main-footer'
import MainHead from './../components/main-head'

export default {
  components: {
    MainHead, MainFooter
  }
}
</script>

<style scoped lang="scss">
.routerView {
  width: 100%;
  text-align: center;
  //position: absolute;
  z-index: 0;
  top: 70px;
}
</style>
